export default {
  loading: "Memuat...",
  open: "Buka",
  close: "Menutup",
  stake: "Taruhan",
  crdr: "Menang / Kalah",
  item: "Barang",
  valid: "Valid",
  home_preferences: "Halaman Rumah",
  quick_links: "Quick Links",
  language: "Language",
  home_page: "Home",
  favorites: "Favorit",
  note: "Catatan",
  my_bets: "Taruhan Saya",
  my_account: "Akun Saya",
  contact_us: "Hubungi Kami",
  report: "Melaporkan",
  help_support: "Bantuan & Dukungan",
  currency: "Mata Uangnya",
  others: "Lain",
  welcome: "Selamat Datang",
  account_id: "ID Akun",
  password: "kata sandi",
  account: "Rekening",
  all_sports: "Semua Olahraga",
  my_sports: "Olahraga",
  action: "Tindakan",
  accept_better_odds: "Terima Odds yang Lebih Baik",
  accept_any_odds: "Terima Odd Apa Saja",
  auto_refresh_odds: "Penyegaran Odd Otomatis",
  auto_refresh: "Refresh Otomatis",
  auto_refreshing: "Refresh Otomatis...",
  all_markets: "Semua Pasar",
  available_balance: "Saldo Tersedia",
  athletics: "Atletik",
  american_football: "sepak bola amerika",
  aussie_rules_football: "Peraturan sepakbola Australia",
  gmail: "Gmail",
  contact_number: "nomor kontak",

  away: "Tim Tamu",

  all: "Semua",
  accepted: "Diterima",
  add: "Tambah",
  add_homescreen: "Tambah ke Homescreen",
  abandoned: "Abandoned",

  bet_slip: "Slip taruhan",
  bet_credit: "Kredit Taruhan",
  bet_list: "Daftar Taruhan",
  betting: "Bertaruh",
  balance: "Saldo",

  betting_statement: "Laporan Taruhan",
  betting_rules: "Aturan Taruhan",
  bet_types: "Tipe Taruhan",
  bs: "B/S",
  bet_summary: "Bet Summary",
  bets: "Taruhan",
  basketball: "Bola Basket",
  baseball: "Bisbol",
  badminton: "Bulu Tangkis",
  bandy: "Bandy",
  boxing: "Tinju",
  beach_soccer: "Sepak Bola Pantai",

  casino: "Kasino",
  cash_balance: "Saldo Tunai",
  change_account_password: "Ubah Kata Sandi Akun",
  current_password: "Kata sandi saat ini",
  confirm_new_password: "Konfirmasi Kata Sandi Baru",
  customize_sports_order: "Sesuaikan Urutan Olahraga",
  choice: "Pilihan",
  credit: "Kredit",
  commission: "Komisi",
  customize: "Kustomisasi",
  cancel: "Batal",
  confirmation: "Konfirmasi",
  continue_bet: "Continue Bet",
  customer_service: "Hotline Layanan Pelanggan",
  cricket: "Kriket",
  cycling: "Balap Sepeda",
  copa_america: "Copa America",
  combinations: "Kombinasi",
  create_room: "Buat Kamar",

  darts: "Darts",
  debit: "Debit",
  display_language: "Tampilkan Bahasa",
  default_event_sorting: "Penyortiran Acara Default",
  default_stake: "Taruhan Default",
  date: "Tanggal",
  draw: "Seri",
  draw_cancel: "Seri",
  dec: "Odds Desimal",
  double_line: "Spasi Ganda",
  disable: "Disabilitas",
  dec_odds: "DEC | Odds Desimal",
  id_odds: "IND | Odds Indo",
  double_chance: "Peluang Ganda",
  details: "Rincian",

  enable: "memungkinkan",
  event_sorting: "Penyortiran Acara",
  e_sports: "E-Sports",
  esports2: "E-Sports 2",
  edit: "Edit",
  early: "Awal",
  event: "Permainan",
  even: "Genap",
  email: "Email",
  esports: "E-Sports",
  euro: "EURO 2020",
  entry_fee: "Biaya Masuk",
  exclusive: "Eksklusif",

  es_101: "Map 1",
  es_102: "Map 2",
  es_103: "Map 3",
  es_104: "Map 4",
  es_105: "Map 5",
  es_106: "Map 6",
  es_107: "Map 7",
  es_108: "Map 8",
  es_109: "Map 9",
  es_110: "Map 10",
  euroDate: "12 JUNE - 12 JULY",

  fd_101: "1ST Prize",
  fd_102: "2ND Prize",
  fd_103: "3RD Prize",

  first_goal: "Gol Pertama",
  first_half: "Skor Babak Pertama",
  final: "Skor Akhir",
  full_time: "Waktu Penuh",
  fold: "Lipatan",
  from: "Dari",
  field_hockey: "Hoki Lapangan",
  futsal: "Futsal",
  fd: "4D Special",
  fishing: "Fishing",

  gaelic_football: "SEPAK BOLA GAELIC",
  golf: "Golf",
  games: "Permainan",
  given_credit: "Kredit Yang Diberikan",
  group: "Group",
  goal: "Gol",
  general: "Umum",
  general_betting_rules: "Aturan Taruhan Umum",
  general_rules_market: "Aturan Umum Aturan Pasar (Jenis Taruhan)",

  half_time: "Babak Pertama",
  hide_header: "Sembunyikan Header",
  hk: "Odds Hongkong",
  hk_odds: "HK | Odds Hongkong",
  hdp: "HDP",
  home: "Home",
  hotline: "Hotline",
  handball: "Bola Tangan",
  hurling: "HURLING",
  hour: "Jam",
  highlight: "Sorotan",

  id: "ID",
  ice_hockey: "Hoki Es",

  joined: "Hanya bergabung",
  join_now: "Gabung Sekarang",
  jackpot: "Jackpot",
  
  keno: "Keno",
  kickoff: "Permainan Dimulai",
  kabbadi: "Kabaddi",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "Kalah",
  lose_half: "Kalah Separuh",
  lottery: "Lotere",
  login: "Login",
  logout: "Keluar",
  last_login: "Login Terakhir",
  last_transaction: "Transaksi Terakhir",
  live_streaming: "Streaming Langsung",
  live_match: "Pertandingan Langsung",
  live_chat: "Chat Langsung",
  live: "Langsung",
  live_tv: "TV Langsung",
  livecasino: "Live Kasino",
  loss: "Kerugian",
  lost: "Kerugian",
  last_bet: "Taruhan Terakhir",
  last_goal: "Gol Terakhir",
  leave_room: "Tinggalkan Kamar",
  last_betting_time: "Waktu Taruhan Terakhir",
  lose_all: "Kalah Semua",

  mobile: "Mobil",
  message: "Pesan",
  my_bet: "Taruhan Saya",
  my_favorites: "Favorit Saya",
  market_type: "Jenis Pasar",
  match: "Permainan",
  message_history: "Riwayat Pesan",
  my: "MY",
  market: "Pasar",
  main_markets: "Pasar Utama",
  my_odds: "MY | Odds Malaysia",
  min: "Mnt",
  max: "Maks",
  max_payout: "Pembayaran Maks",
  main: "Pasar Utama",
  corners: "Tendangan Sudut/Kartu",
  specials: "Spesial",
  mix_parlay: "Taruhan Campuran",
  mma: "Seni Bela Diri Campuran",
  motorsports: "Balap Motor",
  muay_thai: "Muay Thai",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "Pertandingan",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "Tidak Ada Gol",
  normal_announcements: "Pengumuman Normal",
  nickname: "Nama panggilan",
  new_password: "Kata Sandi Baru",
  new: "Baru",
  "no/": "No.",
  normal_sorting: "Penyortiran normal",
  netball: "Bola Keranjang",
  newsinfo: "Berita & Info",
  next: "Selanjutnya",

  olympic: "Olimpiade",
  other_markets: "Pasar Lain",
  outstanding: "Taruhan Berjalan",
  odds_type: "Tipe Odd",
  odds: "Odd",
  opening_balance: "Saldo awal",
  outright: "Outright",
  oe: "Ganjil/Genap",
  on: "HIDUP",
  off: "MATI",
  outstanding_bet: "Taruhan luar biasa",
  over: "Besar",
  odd: "Ganjil",
  official_link: "Official Link",
  owner: "Pemilik kamar",

  password_expiry: "Tanggal Kadaluwarsa Kata Sandi",
  parlay: "Parlay",
  parlay_early: "Parlay Early",
  mmo_parlay: "Myanmar Parlay",
  mmo_odds: "Myanmar Odds",
  page_display: "Tampilan Halaman",
  page_type: "Jenis Halaman",
  page_size: "Ukuran halaman",
  personal_message: "Pesan Pribadi",
  process_bet: "Proses Taruhan",
  payout: "Pembayaran",
  pending: "Tertunda",
  personal: "Pribadi",
  play_now: "Play Now",
  parlay_generator: "Parlay Generator",
  private: "Pribadi",
  pool: "Pembayaran $",
  players: "Pemain",
  points: "Poin",
  prize: "Hadiah",
  play_to_earn: "Play to Earn",

  quick_bet: "TARUHAN CEPAT",
  qq: "QQ",

  room: "Kamar",
  result: "Hasil",
  restore: "Restore",
  remark: "Keterangan",
  ref_no: "Nomor referensi",
  remove_from_parlay: "Remove From Parlay",
  running: "Berjalan",
  reject: "Batal",
  rugby: "Permainan Rugby",
  roundof16: "Rounds of 16",
  quater_finals: "Quater Finals",
  semi_finals: "Semi Finals",
  room_id: "ID kamar",
  refund: "Refund",

  skype: "Skype",
  sports: "Olahraga",
  show_balance: "Tampilan saldo",
  statement: "Laporan",
  settings: "Pengaturan",
  search_team: "Cari Tim",
  show_header: "Tampilkan Header",
  submit: "Ajukan",
  set_nickname: "Atur Nama Panggilan",
  single: "Single",
  save: "Menyimpan",
  show_score_map: "Tampilkan Peta Skor",
  status: "Status",
  sort: "Menyortir",
  sportsbook: "Buku Olahraga",
  sum: "SUM",
  special_announcements: "Pengumuman Khusus",
  subtotal: "Subtotal",
  single_line: "Spasi Tunggal",
  sort_by_time: "Sortir Menurut Waktu",
  slots: "Slot",
  select_leagues: "Pilih Liga",
  special: "Spesial",
  scroll_bottom: "Tekan untuk menggulir ke area taruhan",
  swipe_to_search: "Geser ke Pencarian",
  soccer: "SEPAK BOLA",
  squash: "Skuas",
  sepak_takraw: "Sepak Takraw",
  snooker: "Snooker/Pool",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Rangkaian Macau",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet ",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  sfv_101: "Round 1",
  sfv_102: "Round 2",
  sfv_103: "Round 3",
  sfv_104: "Round 4",
  sfv_105: "Round 5",
  settlement: "Settlement",
  settled_amount: "Settlement Amount",
  settled: "Lunas",
  search: "Cari",
  sysparlay: "System Parlay",
  stake_per_bet: "Stake Per Bet",
  score: "Skor",
  winner: "Pemenang",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  selected: "Terpilih",
  select_matches: "Pilih Kecocokan",

  turnover: "Omset",
  today: "Hari Ini",
  time: "waktu",
  team: "Tim",
  to: "untuk",
  trans_time: "Waktu Trans.",
  total: "Jumlah",
  total_goal: "Jumlah Gol",
  treble: "Treble",
  total_bets: "Jumlah Taruhan",
  tnc: "General Terms & Conditions",
  tennis: "Tenis",
  table_tennis: "Tenis Meja",
  telegram: "telegram",
  total_stake: "Jumlah Taruhan",
  tomorrow: "Besok",
  tournament_refund: "Turnamen Refund",

  under: "Kecil",
  void: "Dibatalkan",
  volleyball: "Bola Voli",
  void_list: "Void List",
  view_odds: "Lihat Odds",
  video: "Video",

  won_all: "Menang Semua",
  won_half: "Menang Separuh",
  win_half: "Menang Separuh",
  win: "Menang",
  won: "Menang",
  waiting: "Menunggu",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "Winter Sports",
  water_polo: "Polo Air",
  winlose: "Menang/Kalah",
  winner_rank: "Peringkat Pemenang",

  yes: "Ya",
  no: "Tidak",

  yesterday: "Kemarin",
  monday: "Senin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Kamis",
  friday: "Jumat",
  saturday: "Sabtu",
  sunday: "Minggu",

  all_league: "Semua Liga",
  match_completed: "Selesai",
  match_pending: "Hasil Tertunda",
  match_cancelled: "Penggantian Dana",
  match_cancelled_1h: "Penggantian Dana 1H",
  match_cancelled_2h: "Penggantian Dana 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",

  check_all: "Periksa Semua",
  selected_only: "Hanya yang Dipilih",
  filtered: "Tersaring",
  turn_on: "HIDUP",
  turn_off: "MATI",

  more_bet_types: "Lebih Jenis Taruhan",
  switch_to_desktop: "Beralih ke desktop",

  events: "Permainan",
  brackets: "Brackets",
  standing: "Standing",

  big_small: "Besar/Kecil",
  odd_even: "Ganjil/Genap",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total of Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  total_winlose: "Jumlah Menang/Kalah",
  tournament: "Turnamen",
  total_points: "Total Poin",

  news: "Berita",
  more: "Lebih",
  settled_remark: "Catatan: Taruhan dari pasar hari ini ditampilkan, tiket pertandingan yang telah diselesaikan akan dipindahkan ke pernyataan.",
  w4d: "4D",
  deselect_all: "Hapus Semua",
  select_all: "Pilih Semua",
  done: "Selesai",
  tutorial_tooltips: "Cara memasang aplikasi ini di layar beranda",
  tutorial: "Tutorial",
  dismiss: "Batal",
  seven_days: "7 Hari Terakhir",
  fourteen_days: "14 Hari Terakhir",

  hide: "Hide",
  more_details: "Lebih detail",
  transfer: "Transfer",
  goto_statement: "Pergi ke Laporan",
  no_record: "Tidak ada catatan yang ditemukan",
  no_bet: "Tidak ada taruhan",

  random_pick: "Generate",
  add_pick: "Add To Bet Slip",

  worldcup: "WORLD CUP 2022",
  time_remaining: "Sisa Waktu",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",
  egames: "V-Games",
  feedback: "Umpan Balik Pengguna",
  ranking: "Peringkat",
  total_winning: "Total Kemenangan",
  first_prize: "Hadiah Pertama",
  second_prize: "Hadiah Kedua",
  third_prize: "Hadiah Ketiga",
  place: "Peringkat",
  current_point: "Poin Saat Ini",
  free_room: "Kamar Gratis",
  last_join_time: "Waktu Bergabung Terakhir",
  archery: "Panahan",
  winter_olympic: "Olimpiade Musim Dingin",
  no1: "Pemenang Tempat Pertama",
  adjustment: "Pengaturan",
  poker: "Poker",
  poker_db: "DB Poker",
  yellow: "Kuning",
  blue: "Biru",
  first_ball: "Bola Pertama",
  best_5_balls: "5 Bola Terbaik"
};
